import React from "react";
import {
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";

const CardData = ({ data }) => {
  return (
    <Row className="mb-4">
      {data.map((d) => (
        <Col className="mb-3" key={d._id}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <NavLink to={d.link} style={{textDecoration:"none", color:"#4b5563"}}>
              <div className="d-flex align-items-center justify-content-between">
                <h6>{d.label}</h6>
                <div className="icon">{d.icon}</div>
              </div>
              <h2>{d.count}</h2>
              </NavLink>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
export default CardData;
